/**
 * @generated SignedSource<<dd2d7fd906ad8d8f44ee59cbd345bbaf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type useTodoCreateAddImageMutation$variables = Record<PropertyKey, never>;
export type useTodoCreateAddImageMutation$data = {
  readonly uploadImageLink: {
    readonly image: {
      readonly id: string;
    };
    readonly url: string;
  } | null;
};
export type useTodoCreateAddImageMutation = {
  response: useTodoCreateAddImageMutation$data;
  variables: useTodoCreateAddImageMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "UploadImageLinkResponse",
    "kind": "LinkedField",
    "name": "uploadImageLink",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Image",
        "kind": "LinkedField",
        "name": "image",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useTodoCreateAddImageMutation",
    "selections": (v0/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useTodoCreateAddImageMutation",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "e9a554891078792982ca94eaef50cd41",
    "id": null,
    "metadata": {},
    "name": "useTodoCreateAddImageMutation",
    "operationKind": "mutation",
    "text": "mutation useTodoCreateAddImageMutation {\n  uploadImageLink {\n    image {\n      id\n    }\n    url\n  }\n}\n"
  }
};
})();

(node as any).hash = "31113392bfade6ed98179131f6d2abc2";

export default node;
